module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-4a238a5967b0b0179cfebcfd697e1e49.png";